import React from 'react'

const Footer = () => {
    return (
        <div className="container footer-container">
            <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
                <div className="col-md-4 d-flex align-items-center">
                    <span className="text-muted">© 2023 Webplanex Infotech</span>
                </div>

                <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
                    <li className="ms-3">
                        <span className="text-muted">
                            <i className="fa-brands fa-twitter"></i>
                        </span>
                    </li>
                    <li className="ms-3">
                        <span className="text-muted">
                            <i className="fa-brands fa-instagram"></i>
                        </span>
                    </li>
                    <li className="ms-3">
                        <span className="text-muted">
                            <i className="fa-brands fa-facebook"></i>
                        </span>
                    </li>
                </ul>
            </footer>
        </div>
    )
}

export default Footer